import $ from 'zepto-modules';
let template = require('art-template/lib/template-web.js');
require('./pop');
/**
 * 生产环境定义
 */
const PRODUCT_MODEL = 'production'

/**
 * 模板的扩展方法
 * @param {*} name 
 * @param {*} func 
 */
template.helper = function(name, func){
    template.defaults.imports[name] = func;
}

Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1, //month
        "d+": this.getDate(), //day
        "h+": this.getHours(), //hour
        "m+": this.getMinutes(), //minute
        "s+": this.getSeconds(), //second
        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
        "S": this.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

/**
 * 公共方法
 */
let common = {
    /**
     * 模板相关处理
     */
    template:template,

    /**
     * url相关处理
     */
    url:{
        /**
         * 根据当前环境（开发/生产）返回指定路径的url地址
         * @param {指定的路径} path
         */
        getPrimaryStationUrl:function(path){
            if(process.env.NODE_ENV === PRODUCT_MODEL){
                return `../../../${path}`
            }else{
                return `http://localhost:8080/${path}`
            }
        } 
    },

    /**
     * ajax请求相关处理
     */
    ajax:{
        /**
         * ajax get请求
         * @param {请求的地址} url
         * @param {请求的参数} data
         * @param {请求成功的回调} sucfn
         * @param {请求失败的回调} errfn
         * @param {请求之前的回调} befn
         * @param {请求完成的回调} compfn
         * @param {请求超时时间设置} timeout
         */
        get:function(url, data, sucfn, errfn, befn, compfn, timeout){
            var xhrQuote = $.ajax({
                url: url + (url.indexOf('?') == -1 ? '?' : '&') + 'timestamp=' + new Date().getTime(),
                type: "GET",
                timeout: timeout || 15000,
                data: data || {},
                dataType: "json",
                beforeSend: function () {
                    befn && befn();
                },
                success: function (result) {
                    sucfn && sucfn(result);
                },
                error: function (result) {
                    errfn ? errfn() : common.dialog('连接失败,请检查网络');
                },
                complete: function (XMLHttpRequest, theStatus) {
                    compfn && compfn(XMLHttpRequest, theStatus);
                }
            })
            return xhrQuote;
        },

        /**
         * ajax post请求
         * @param {请求的地址} url
         * @param {请求的参数} data
         * @param {请求成功的回调} sucfn
         * @param {请求失败的回调} errfn
         * @param {请求之前的回调} befn
         * @param {请求完成的回调} compfn
         * @param {请求超时时间设置} timeout
         */
        post:function(url, data, sucfn, errfn, befn, compfn, timeout){
            var xhrQuote = $.ajax({
                url: url + (url.indexOf('?') == -1 ? '?' : '&') + 'timestamp=' + new Date().getTime(),
                type: "POST",
                timeout: timeout || 15000,
                data: data || {},
                dataType: "json",
                beforeSend: function (xhr) {
                    befn && befn();
                },
                success: function (result) {
                    sucfn && sucfn(result);
                },
                error: function (result) {
                    errfn ? errfn() : common.dialog('连接失败,请检查网络')
                },
                complete: function (XMLHttpRequest, theStatus) {
                    compfn && compfn(XMLHttpRequest, theStatus)
                }
            })
            return xhrQuote;
        }
    },
    date:{
        format: function(string ){

        }
    },
    /**
     * 公共的弹框提示
     * @param {提示信息} message
     * @param {提示标题} title
     * @param {确认的回调} okFn
     * @param {弹框样式} popClass
     * @param {确认按钮文字} okBtnText
     * @param {取消按钮文字} cancelBtnText
     * @param {取消时的回调} cancelFn
     * @param {展示时的回调} onShowFn
     * @param {内容是否可滑动} touchMove
     */
    dialog: function (message, title, okFn, popClass, okBtnText, cancelBtnText, cancelFn, onShowFn, touchMove) {
        $('body').popup({
            title: title || '温馨提示',
            message: message || '',
            popClass: popClass || 'pop-c-one',
            ok: okBtnText || "确定",
            cnacel: cancelBtnText || "取消",
            touchmove: touchMove || false,
            onOk: okFn ? okFn : function () { },
            onCancel: cancelFn ? cancelFn : function () { },
            onShow: onShowFn ? onShowFn : function () { }
        }) 
    }
}

export default common;